<mat-toolbar>
    <span class="pointer">Aide</span>
    <span class="spacer"></span>
</mat-toolbar>
<div class="help-container">
        @if (activiteAdherent == 'gpo') {
        <p class="text-content">
  Si vous avez des questions, vous pouvez contacter le responsable à l’email suivant :
    <a [href]="'mailto:' + emailsResponsables">
    <strong>{{ emailsResponsables }}</strong>
  </a>
</p>

    } @else {

    <p class="text-content">Une plateforme est mise en place afin de répondre à vos demandes.</p>


    <p class="text-content">Si vous rencontrez des problèmes de connexion, des difficultés de compréhension
        d'indicateurs ou de visuels ou si
        vous
        remarquez des anomalies au niveau de vos données vous pouvez nous contacter de la manière suivante :</p>
    <p class="text-content">Utilisez le lien suivant afin de créer un ticket : <a
            href="https://assistance.lafsante.com/portal/fr/newticket"
            target="_blank">https://assistance.lafsante.com/portal/fr/newticket
        </a>
    </p>
    <div><img src="./assets/images/ticket-help.png" alt="Capture d'écran du portail d'aide" /></div>


    <p class="text-content">Remplissez les champs obligatoires.</p>
    <ul>
        <li class="text-content">Dans la section Macro-sujets, choisissez “Plateforme adhérents”.</li>

        <li class="text-content">N’hésitez pas à joindre des captures d'écrans afin d’illustrer le problème rencontré.
        </li>
    </ul>

   }

</div>